import { DragEvent, FC, useState } from "react";
import { AVATAR_ACCEPT } from "../model/validateAvatarFile";

import styles from "./ProfileAvatar.module.css";

interface Props {
  disabled: boolean;
  onFile: (file: File) => void;
}

export const AvatarDropzone: FC<Props> = ({ disabled, onFile }) => {
  const [isDragOver, setIsDragOver] = useState(false);

  const pickFile = (files: FileList | null) => {
    const file = files?.[0];
    if (file && !disabled) onFile(file);
  };

  const handleDragOver = (event: DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDrop = (event: DragEvent<HTMLLabelElement>) => {
    event.preventDefault();
    setIsDragOver(false);
    pickFile(event.dataTransfer.files);
  };

  return (
    <label
      className={`${styles.dropzone} ${isDragOver ? styles.dragOver : ""}`}
      aria-disabled={disabled}
      onDragOver={handleDragOver}
      onDragLeave={() => setIsDragOver(false)}
      onDrop={handleDrop}
    >
      <input
        type="file"
        hidden
        accept={AVATAR_ACCEPT}
        disabled={disabled}
        onChange={(event) => {
          pickFile(event.target.files);
          // Сброс, чтобы повторный выбор того же файла снова вызвал onChange.
          event.target.value = "";
        }}
      />
      {disabled ? "Please wait..." : "Click or Drop Image here"}
    </label>
  );
};
